import styled from "styled-components";

export const AdsContainer = styled.div`
  min-height: 130px;
  .stickyAdsBottom {
    position: fixed !important;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 15;
  }
`;
export const HomeAdsHeight = styled.div`
   ${({ theme: { isDesktop } }) =>
    isDesktop ? "height:90px": "height:266px"}
`;

export const AddPostCont = styled.div<{hasSMCAd}> `
   ${({theme: {isMobile}, hasSMCAd}) =>
       (isMobile && hasSMCAd) ? `bottom:97px` : `bottom:32px;`};
   button{
      border-radius:50px;
      padding:8px 20px
   }
`;
